import React, { PropTypes } from 'react';
import partial from 'lodash/partial';
import { Link } from 'react-router';
import SubcategoryName from 'common/containers/subcategory_name';
import RemoveModal from 'your_projects/containers/remove_draft_modal';
import ProjectLink from 'common/containers/project_link';

const DraftProjects = ({ items, toggleRemoveModal }) => {
  return (
    <div>
      <table className="table table-default drafts">
        <thead>
          <tr>
            <td>Project</td>
            <td className="hide-for-small-only">Category</td>
            <td>Award</td>
            <td className="hide-for-small-only">Package</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          { items.map((draft) => {
            /* project can also be under 1-1 negotiation... */
            const isDraft = draft.status === 'draft';

            return (
              <tr key={draft.id}>
                <td className="project-name">
                  { isDraft?
                  <Link to={`/start-a-project/${draft.id}/review/`}>
                    {draft.title || 'THIS PROJECT NEEDS A TITLE'}
                  </Link>:
                  <ProjectLink project={draft} /> }
                </td>
                <td className="hide-for-small-only"><SubcategoryName id={draft.sub_category} /></td>
                <td>${draft.total_awards_and_tips}</td>
                <td className="hide-for-small-only">{ draft.package_name }</td>
                <td>
                  <button className="btn btn-icon-only" onClick={partial(toggleRemoveModal, draft)}>
                    <i className="fa fa-times-circle"/>
                  </button>
                </td>
              </tr>
            );
          }) }
        </tbody>
      </table>

      <RemoveModal />
    </div>
  );
};

DraftProjects.propTypes = {
  items: PropTypes.array.isRequired,
  toggleRemoveModal: PropTypes.func.isRequired,
};

export default DraftProjects;



// WEBPACK FOOTER //
// ./your_projects/components/draft_projects.jsx